// @flow
import JQueryView from '../../common/JQueryView';
import changePasswordValidator from '../changePasswordValidator';

export default class ChangePasswordForm extends JQueryView {
  constructor() {
    super('.change-password-form-wrapper');
    this.render();
  }

  render() {
    changePasswordValidator();
  }
}
